import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["slider"]

  connect() {
    this.originalDisplays = {}
    
    this.sliderTargets.forEach((slider, index) => {
      const displaySpan = slider.nextElementSibling
      this.originalDisplays[index] = displaySpan.textContent.trim()
    })
  }

  updateDisplay(event) {
    const slider = event.target
    const displaySpan = slider.nextElementSibling
    const fieldName = slider.dataset.fieldName
    
    const hiddenField = this.element.querySelector(`input[type="hidden"][name*="${fieldName}"]`)
    
    // Get the label for the current value
    const value = parseInt(slider.value)
    console.log("Slider value:", value)
    
    let label
    if (value === 0) {
      label = "0 (low)"
    } else if (value === 2) {
      label = "2 (medium)"
    } else if (value === 4) {
      label = "4 (high)"
    } else {
      label = value.toString()
    }
    
    console.log("Setting label to:", label)
    displaySpan.textContent = label
    
    if (hiddenField) {
      hiddenField.value = slider.value
    }
  }
} 